import { useEffect } from 'react';
import { formatIsoDate } from '@front-activerse/common-components';

import DayPlan from './components/DayPlan';
import DayPlanSummary from './components/DayPlanSummary';
import Meal from './components/DayPlanMeal';
import DayPlanStats from './components/DayPlanStats';

const DayViewContainer = ({
  renderTimeline,
  dailyDietPlan,
  availableDays,
  categories,
  goal,
  isHolidayMenu,
  isTimeToNagForCurrentMeasurement,
  alreadyCopied,
  prefetchSurroundingDays,
  prefetchMealDetails,
  dietId,
  copyDayPlan,
  addMealToFavorites,
  removeMealFromFavorites,
  setMealEaten,
  recipeNotesForNextDay,
  intermittentFasting,
  loadDayPlanMealReplacements,
  setUserFlagData,
  dietPlanIntroSeen,
  mealPlanNavigation,
  mealPlanNotificationData,
  closedNotifications,
  userId,
  getClosedNotificationsValues,
  markNotificationAsClosed,
  loadingMealPlanNotification,
}) => {
  useEffect(() => {
    runPrefetchMealDetails();
    prefetchSurroundingDays();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dailyDietPlan.date]);

  const runPrefetchMealDetails = () => {
    dailyDietPlan.events.map((event) => {
      if (event.__typename === 'UserDailyDietPlanEventMeal') {
        prefetchMealDetails(dailyDietPlan.setId, event.mealType.type, event.id);
      }
      return null;
    });
  };

  const renderEvents = (events) => (
    <>
      {events.map((event) => {
        if (event.__typename === 'UserDailyDietPlanEventMeal') {
          return (
            <Meal
              key={event.key}
              mealKey={event.key}
              mealId={event.id}
              originalMealId={event.originalMeal ? event.originalMeal.id : null}
              dietPhase={dailyDietPlan.dayDiet.phase.identifier.toLowerCase()}
              preparationTime={event.preparationTime}
              name={event.mealType.name}
              mealType={event.mealType.type}
              kcal={event.kcal}
              macro={event.macro}
              showMacros={dailyDietPlan.showMacros}
              loadDayPlanMealReplacements={loadDayPlanMealReplacements}
              dishes={event.dishes}
              setMealEaten={setMealEaten}
              setId={dailyDietPlan.setId}
              preparationImageUrl={event.preparationImageUrl}
              publicName={event.name}
              addMealToFavorites={addMealToFavorites}
              removeMealFromFavorites={removeMealFromFavorites}
              canBeAddedToFavorites={event.canBeAddedToFavorites}
              isFavorite={event.isFavorite}
              isEaten={event.isEaten}
              date={formatIsoDate(dailyDietPlan.date)}
              mealCustomTag={event.mealCustomTag}
            >
              {() => this.renderDishes(event.dishes, event.name, event.preparationVideoUrl)}
            </Meal>
          );
        }
        return '';
      })}
    </>
  );

  const renderSummary = (canBeCopiedToDate, alreadyCopied) => (
    <DayPlanSummary
      protein={dailyDietPlan.dayDiet.macro.protein.percentage}
      fat={dailyDietPlan.dayDiet.macro.fat.percentage}
      carbohydrates={dailyDietPlan.dayDiet.macro.carbohydrates.percentage}
      canBeCopiedToDate={canBeCopiedToDate}
      copyDayPlan={copyDayPlan}
      alreadyCopied={alreadyCopied}
      date={formatIsoDate(dailyDietPlan.date)}
    />
  );

  const renderDietStats = () => (
    <DayPlanStats kcal={dailyDietPlan.dayDiet.kcal} meals={dailyDietPlan.events} />
  );

  return (
    <DayPlan
      kcal={dailyDietPlan.dayDiet.kcal}
      macro={dailyDietPlan.dayDiet.macro}
      showMacros={dailyDietPlan.showMacros}
      date={dailyDietPlan.date}
      name={dailyDietPlan.dayDiet.name}
      phase={dailyDietPlan.dayDiet.phase}
      price={dailyDietPlan.price}
      goal={goal}
      isHolidayMenu={isHolidayMenu}
      isTimeToNagForCurrentMeasurement={isTimeToNagForCurrentMeasurement}
      availableDays={availableDays}
      categories={categories}
      renderTimeline={(position) => renderTimeline(position)}
      recipeNotesForNextDay={recipeNotesForNextDay}
      intermittentFasting={intermittentFasting}
      setUserFlagData={setUserFlagData}
      dietPlanIntroSeen={dietPlanIntroSeen}
      mealPlanNavigation={mealPlanNavigation}
      dietTypeName={dailyDietPlan.dayDiet.name}
      mealPlanNotificationData={mealPlanNotificationData}
      closedNotifications={closedNotifications}
      userId={userId}
      getClosedNotificationsValues={getClosedNotificationsValues}
      markNotificationAsClosed={markNotificationAsClosed}
      loadingMealPlanNotification={loadingMealPlanNotification}
    >
      {() => (
        <>
          {renderDietStats()}
          {renderEvents(dailyDietPlan.events)}
          {renderSummary(dailyDietPlan.canBeCopiedToDate, alreadyCopied)}
        </>
      )}
    </DayPlan>
  );
};

export default DayViewContainer;
